/**
 * `settingsFile.ts`'nin web karşılığı: ayarlar bu tarayıcının yerel deposunda.
 * Masaüstündeki `settings.json` gibi cihaza özel; ayar mantığı (varsayılanlar,
 * doğrulama) ortak settings.ts'te. Sunucunun da bilmesi gereken tercihler
 * (özet dili, şablon, terimler) oradan prefsSync ile `user_preferences`'a
 * yazılıyor; ilk açılışta oradan okunuyor (bkz. bridge.ts > hydratePreferences).
 */

const KEY = 'talknote-ayarlar';

export function settingsFilePath(): string {
  return `localStorage:${KEY}`;
}

export async function readSettingsFile(): Promise<unknown> {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export async function writeSettingsFile(value: unknown): Promise<void> {
  try {
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch (err) {
    // Gizli pencere / dolu depo: ayar bu oturumda bellekte kalır (settings.ts önbelleği).
    console.warn('[settings] tarayıcıya yazılamadı:', (err as Error).message);
  }
}
